import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import Hero from './components/Hero';
import IntroSection from './components/IntroSection';
import CastSection from './components/CastSection';
import EpisodeSection from './components/EpisodeSection';
import HighlightSection from './components/HighlightSection';
import PlotSection from './components/PlotSection';
import GuideSection from './components/GuideSection';
import ReviewSection from './components/ReviewSection';
import FaqSection from './components/FaqSection';
import RelatedSection from './components/RelatedSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-body">
      <SiteHeader />
      <main>
        <Hero />
        <IntroSection />
        <CastSection />
        <EpisodeSection />
        <HighlightSection />
        <PlotSection />
        <GuideSection />
        <ReviewSection />
        <FaqSection />
        <RelatedSection />
      </main>
      <SiteFooter />
    </div>
  );
}